import { useRouter } from 'next/router'
import useSeti from './useSeti'
import { AMENITIES } from '../SearchForm/constants'

export default function useSEMSearchHeadline(setiName: string) {
  const { query } = useRouter()
  const { SEMSearch, SEMSEARCH } = query
  const semSearch = ((SEMSearch || SEMSEARCH) as string)?.toUpperCase()
  const amenityHeadline = AMENITIES[semSearch as keyof typeof AMENITIES]
  const isSEMHotelsSeti =
    useSeti(setiName, amenityHeadline !== undefined) !== 'DEFAULT'

  return isSEMHotelsSeti && amenityHeadline ? amenityHeadline : null
}
